import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';

export const bookmarkBulkUpload = (listID, bodyData) => {
  return api.post(URLS.bookmarkBulkUpload, bodyData, {
    params: {
      id: listID
    },
    headers: {
      needsToken: true
    }
  });
};

export const getBulkBookmarkSites = (listID) => {
  return api.get(URLS.bookmarkSites, {
    params: {
      id: listID
    },
    headers: {
      needsToken: true
    }
  });
};

export const bulkUpdateBookmarkSites = (listID, bodyData) => {
  return api.put(URLS.bookmarkSites, bodyData, {
    params: {
      bookmarkId: listID
    },
    headers: {
      needsToken: true
    }
  });
};

export const getBookmarkSitesCount = (bookmarkListID) => {
  return api.get(URLS.bookmarkSitesCount, {
    params: {
      id: bookmarkListID
    },
    headers: {
      needsToken: true
    }
  });
};
